<template lang="pug">
.container-nav
  nav
    .logo-section
      img.logo(src="@/assets/logo.webp" alt="DevPortfolio" @click="$router.push('/espaco-nexa/perfil')")
      .breadcrumb(v-if="breadcrumbText")
        template(v-if="breadcrumbText.full")
          span.current {{ breadcrumbText.full }}
        template(v-else)
          span.path {{ breadcrumbText.path }}
          LucideIcon(name="ChevronRight" :size="16")
          span.current {{ breadcrumbText.current }}
</template>

<script>
export default {
  props: {
    breadcrumbText: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss">
.container-nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $corFundoPadraoDashboard;
  color: $corBranco;
  z-index: 1;
  border-bottom: 1px solid $borderColor;
    
  nav {
    max-width: 1360px;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 30px;
    box-sizing: border-box;

    .logo-section {
      display: flex;
      align-items: center;
      gap: 16px;

      .logo {
        height: 40px;
        width: auto;
        object-fit: contain;
        cursor: pointer;
        transition: opacity 0.2s ease;

        &:hover {
          opacity: 0.8;
        }
      }

      .breadcrumb {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 16px;

        svg {
          color: #6b7280;
        }

        .path {
          color: #6b7280;
          font-weight: 400;
        }

        .current {
          color: $corVerdeClaro;
          font-weight: 600;
        }
      }
    }
  }

  @media screen and (max-width: 600px) {
    nav {
      padding: 0 16px;

      .logo-section {
        gap: 12px;

        .logo {
          height: 32px;
        }

        .breadcrumb {
          font-size: 14px;
        }
      }
    }
  }
}
</style>